// extracted by mini-css-extract-plugin
export default {"selected":"IconMenuItem_selected__+U817","listItem":"IconMenuItem_listItem__qYVe3","extraWidth":"IconMenuItem_extraWidth__FiU3W"};